import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-130">
      <div className="max-w-3xl mx-auto" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-132">
          <p className="text-xl md:text-2xl text-slate-700 leading-relaxed font-medium italic border-l-4 border-gold pl-6" data-id="element-133">
            Entras al supermercado, miras los precios y sientes ese nudo en el
            estómago. Sabes que, aunque trabajes más horas, el dinero se esfuma
            antes de llegar al próximo cheque. La inflación en Estados Unidos no
            es una noticia de televisión, es algo que te quita el sueño todas
            las noches al pagar la renta y los "bills".
          </p>

          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-134">
            Pero mientras la mayoría se resigna a sobrevivir, un grupo de
            mujeres latinas ha descubierto una salida de emergencia: las{' '}
            <strong className="text-navy-900" data-id="element-135">
              Tiendas Digitales de Bajo Mantenimiento
            </strong>
            .
          </p>

          <div className="pt-8" data-id="element-136">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-137">
              El problema no es que no "eches ganas"
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-138">
              El problema es que te enseñaron que para ganar dinero extra en
              este país tenías que vender comida, limpiar casas o invertir miles
              de dólares en inventario físico que termina llenando tu garaje.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-139">
              Ese modelo es lento, cansado y arriesgado. Si no vendes el
              producto físico, pierdes tu inversión. Si te enfermas, no cobras.
              Y lo más triste: pasas más tiempo sirviendo a otros que
              disfrutando con tus propios hijos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}